import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "pa-4 ion-text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "body-2 o-7" }, "Sorry, no articles were found.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_article_card = _resolveComponent("article-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.dashboard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.shellArticle)
            ? (_openBlock(), _createBlock(_component_article_card, {
                key: 0,
                article: _ctx.shellArticle,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/home/articles/' + _ctx.shellArticle.id)))
              }, null, 8, ["article"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherArticles, (oArticle) => {
            return (_openBlock(), _createBlock(_component_article_card, {
              article: oArticle,
              key: 'art1-' + oArticle.id,
              onClick: ($event: any) => (_ctx.$router.push('/home/articles/' + oArticle.id))
            }, null, 8, ["article", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
      return (_openBlock(), _createBlock(_component_article_card, {
        article: article,
        key: 'art-' + article.id,
        onClick: ($event: any) => (_ctx.$router.push('/home/articles/' + article.id))
      }, null, 8, ["article", "onClick"]))
    }), 128)),
    (
      !_ctx.loading &&
      (!_ctx.articles || _ctx.articles.length == 0) &&
      (!_ctx.dashboard || !_ctx.otherArticles || _ctx.otherArticles.length == 0)
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ion_icon, {
            button: "",
            color: "primary",
            class: "auto pa-4 o-7",
            size: "large",
            icon: _ctx.thumbsDownOutline
          }, null, 8, ["icon"]),
          _hoisted_3
        ]))
      : _createCommentVNode("", true)
  ], 64))
}